
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import firebase from "firebase/app";
import "firebase/firestore";
import Dialog from '@material-ui/core/Dialog';
import { blue } from '@material-ui/core/colors';

import ReviewForm from 'Components/ReviewForm';
import CloseIcon from 'img/close-icon.svg';

const useStyles = makeStyles({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
  container: {
    padding: "30px"
  },
  closeBtn: {
    width: "20px",
    cursor: "pointer",
    position: "absolute",
    top: "15px",
    right: "15px"
  }
});

export default function DefinitionDialog({ onClose, open }) {
  const classes = useStyles();
  const [companies, setCompanies] = React.useState([]);

  const handleClose = () => onClose();

  useEffect(() => {
    fetchData()
      .then(setCompanies)
      .catch(error => {
        console.warn(JSON.stringify(error, null, 2));
      })
  }, []);


  const fetchData = async () => {
    let snapshot = await firebase.firestore().collection("company-data").get();
    const companyList = snapshot.docs.map((doc) => doc.data().companyName);
    return companyList;
  }
  
  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} disableScrollLock={true} style={{ margin: 0, width: "100%"}}>
      <div onClick={handleClose}><img className={classes.closeBtn} src={CloseIcon} /></div>
      <div className={classes.container}>
        <ReviewForm companyList={companies} />
      </div>
    </Dialog>
  );
}

DefinitionDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};
